export const DURATION_PRIORITY = [
    [2001, 'duration'],
    [1006, 'videoDuration'],
];
export const EP_UPDATE_PRIORITY = [
    [2003, 'episodeUpdated'],
];
export const CORNER_MARK_PRIORITY = [
    [2001, 'uniImgtag'],
    [2003, 'uniImgtag'],
];
// export const picStrategy = [
// 	[2001, 'pic_360_204'],
// 	[2001, 'pic496x280'],
// 	[1006, 'pic_496_280'],
// 	[2003, 'new_pic_hz'],
// 	[2005, 'new_pic_lt_hz'],
// 	[2010, 'pic_498_280'],
// 	[2010, 'c_pic']
// ]
